<template>
  <div class="note-item" :class="{ self: isSelf }">
    <div class="message">
      <div class="author" v-if="!isSelf">
        {{ author | fullName }}
      </div>
      <v-textarea row-height="1" auto-grow readonly rounded :value="text" />
      <div class="mt-4" v-if="hasAttachments">
        <FileComponent
          class="pb-2"
          v-for="attachment in attachments"
          :key="attachment.id"
          :file="attachment"
          @show="showFile(attachment)"
          customActions
          disabled
          :showFileName="!isMobile"
        />
      </div>
      <PDFViewFull :data="fileDialog" />
    </div>
  </div>
</template>

<script>
import { getToken } from "@/services/utils";
import FileComponent from "@/components/common/FileComponent";
import PDFViewFull from "@/components/common/PDFViewFull";
import { size } from "lodash";

export default {
  props: {
    text: {
      type: String,
      required: false
    },
    author: {
      type: Object,
      required: false
    },
    isSelf: Boolean,
    attachments: Array
  },
  components: { FileComponent, PDFViewFull },
  data() {
    return {
      fileDialog: { dialog: false }
    };
  },
  computed: {
    hasAttachments() {
      return size(this.attachments);
    }
  },
  methods: {
    showFile(attachment) {
      this.fileDialog = {
        src: this.fileUrl(attachment.url),
        title: attachment.name,
        dialog: true
      };
    },
    fileUrl(url) {
      const token = `token=${getToken()}`;
      return `${url}?${token}`;
    }
  }
};
</script>

<style lang="scss">
.note-item {
  display: flex;

  .message {
    width: 100%;

    .author {
      color: $secondary-text;
      margin-bottom: 5px;
    }
  }
  span.grey--text {
    color: $selected;
  }

  .v-text-field .v-input__slot {
    font-style: italic;
    background-color: $yellow-light !important;
    border: none;
  }

  .v-input.v-text-field {
    margin-top: 0px;
  }

  .self {
    flex-direction: row-reverse;
    .v-text-field--rounded > .v-input__control > .v-input__slot {
      background: rgba($primary, 0.15) !important;
      border: none;
    }
  }

  .v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 0 20px;
    background: $background;
    border-radius: 10px;
  }

  .v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 0 20px;
    background: $background;
    border-radius: 10px;
  }

  textarea {
    margin: 5px 0 !important;
    min-height: 38px;
    @include body;
  }

  p {
    margin-bottom: 5px !important;
    margin-left: 5px !important;
  }

  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
}
</style>
